window.dtProduct = function () {
  const dt_product = new DataTable('#product-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#product-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#product-datatable', 6); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[5, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "customer" },
      { "data": "internal_code" },
      { "data": "customer_code" },
      { "data": "name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}
